import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { color, space, font, query } from '@design/templateFns';

export const PlayButton = (): ReactNode => {
  return (
    <StyledPlayButton type="button">
      <StyledSvg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 78 78"
        xmlSpace="preserve"
        overflow="visible"
      >
        <filter id="button-shadow">
          <feDropShadow dx="0" dy="0" stdDeviation="2" floodOpacity="0.15" />
        </filter>
        <circle
          filter="url(#button-shadow)"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="1"
          cx="39"
          cy="39"
          r="38"
        />
        <g className="svg-play-button">
          <ellipse
            filter="url(#button-shadow)"
            fill="#FFFFFF"
            fillOpacity="0.95"
            cx="39"
            cy="39"
            rx="30.5"
            ry="30.5"
          />
          <path
            d="M43.99,38.73l-9.61-6.52c-0.1-0.07-0.23-0.08-0.34-0.02c-0.11,0.06-0.18,0.17-0.18,0.29v13.04c0,0.12,0.07,0.23,0.18,0.29
          c0.05,0.02,0.1,0.04,0.15,0.04c0.07,0,0.13-0.02,0.19-0.06l9.61-6.52c0.09-0.06,0.14-0.16,0.14-0.27
          C44.14,38.89,44.08,38.79,43.99,38.73z"
          />
        </g>
      </StyledSvg>
    </StyledPlayButton>
  );
};

export const StyledPlayButton = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  transition: opacity 0.3s ease-in-out;
  //remove default button styles
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0;
  opacity: 0.9;

  @media screen and (${query.below('tablet')}) {
    width: ${space('x12')};
    height: ${space('x12')};
  }

  @media screen and (${query.below('desktop')}) {
    width: ${space('x10')};
    height: ${space('x10')};
  }
`;

export const StyledSvg = styled.svg`
  transform-origin: 50% 50%;
  transition: all 0.2s ease-in-out;

  &:hover {
    opacity: 1;
    scale: 1.05;
  }

  &:active {
    opacity: 0.8;
    scale: 0.95;
  }
`;
